import React from "react";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import type { NodeProps, Node } from "@xyflow/react";

type SetSeatSensorMutingNode = Node<InterfaceToRecord<ExtraNodeData>>;

export default function SetSeatSensorMuting(
    props: NodeProps<SetSeatSensorMutingNode>,
): JSX.Element {
    return <ActionConfigNode nodeKind={props.type} {...props.data} />;
}
